import { translate as t } from '@fiverr-private/i18n-react';

export const translateMetadataQuestion = ({
    subCategoryId,
    nestedSubcategoryId,
    metadataType,
}: {
    subCategoryId: number;
    nestedSubcategoryId?: number | null;
    metadataType: string;
}): {
    displayName: string;
    questionTitle: string;
} => {
    const key = `dm_categories_metadata.${nestedSubcategoryId ?? subCategoryId}.${metadataType}`;

    return {
        displayName: t(`${key}.display_name`),
        questionTitle: t(`${key}.display_phrase`),
    };
};

export const translateMetadataAnswer = ({
    leafCategoryId,
    answerSlug,
    metadataType,
}: {
    leafCategoryId: number;
    answerSlug: string;
    metadataType: string;
}): string => t(`metadata.category_${leafCategoryId}.${metadataType}.options.${answerSlug}`);
